import {
    Box,
    Heading,
    Icon,
    MediaObject,
    Paragraph,
} from '@zillow/constellation-10';
import { IconFileOutline } from '@zillow/constellation-icons';
import React from 'react';

export interface TermHeroProps {
    /** Total number of articles in the category/tag */
    total?: number;
    /** Category or tag name (may contain HTML) */
    name: string;
    /** Optional description text */
    description?: string;
}

const TermHero: React.FC<TermHeroProps> = ({ total, name, description }) => {
    const articleCountIcon = (
        <Icon size="sm" css={{ color: 'text.subtle' }}>
            <IconFileOutline />
        </Icon>
    );

    return (
        <section>
            <Box
                css={{
                    marginBottom: { base: 'tight', xxl: 'loose' },
                }}
            >
                <MediaObject
                    media={articleCountIcon}
                    css={{
                        gap: 'tightest',
                        alignItems: 'center',
                    }}
                >
                    <Paragraph textStyle="body-sm" color="text.subtle">
                        {total ?? 0} {total === 1 ? 'Article' : 'Articles'}
                    </Paragraph>
                </MediaObject>
            </Box>
            {/* @ts-expect-error - Heading requires children but we're using dangerouslySetInnerHTML */}
            <Heading
                level={1}
                textStyle="responsive.heading-md"
                css={{
                    marginBottom: { base: 'tight', xxl: 'loose' },
                }}
                dangerouslySetInnerHTML={{ __html: name }}
            />
            {description ? (
                <Paragraph
                    color="text.subtle"
                    textStyle="body"
                    css={{
                        marginBottom: {
                            base: 'loose',
                            lg: 'looser',
                            xxl: 'looser',
                        },
                    }}
                >
                    {description}
                </Paragraph>
            ) : null}
        </section>
    );
};

export default TermHero;
